/** The statuses a point value is shown as, instead of a number. */
export const POINT_VALUE = Object.freeze({
  NA: "NA",
  ERROR: "ERROR",
  NO_PROBE: "NO PROBE",
  BAD_LINK: "BAD LINK",
  ON: "ON",
  OFF: "OFF",
});

/** Point vtype values. */
export const VTYPE = Object.freeze({
  ALARM: "alarm",
});
